<template>
  <div
      v-if="open"
      :style="{ top: top + 'px', left: left + 'px', width: width + 'px' }"
      class="lp-side-popover"
      role="dialog">
    <header
        v-if="title"
        class="lp-side-popover__head">
      <span class="lp-side-popover__title">{{ title }}</span>
      <slot name="header-actions"/>
      <button
          type="button"
          class="lp-side-popover__close"
          aria-label="Close"
          @click="$emit('close')">
        <icon name="close-icon"/>
      </button>
    </header>
    <div class="lp-side-popover__body">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name:  'SidePopover',
  props: {
    open:  { type: Boolean, default: false },
    title: { type: String, default: '' },
    top:   { type: Number, default: 0 },
    left:  { type: Number, default: 0 },
    width: { type: Number, default: 280 },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/lp-tokens';

.lp-side-popover {
  position: fixed;
  z-index: 9999;
  border: 1px solid $lp-line;
  border-radius: $lp-radius-panel;
  background: $white;
  box-shadow: $lp-shadow-pop;
  font-family: $lp-sans;
}

.lp-side-popover__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 12px 4px 16px;
}

.lp-side-popover__title {
  flex: 1 1 auto;
  font-size: $lp-fs-title;
  font-weight: 600;
  color: $lp-ink;
}

.lp-side-popover__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: $lp-radius-control;
  background: transparent;
  cursor: pointer;

  &:hover {
    background: $lp-fill;
  }

  ::v-deep .icon {
    min-width: 0;
    min-height: 0;
  }

  ::v-deep svg {
    width: 14px;
    height: 14px;
  }
}

.lp-side-popover__body {
  padding: 8px 16px 16px;
}
</style>
